import { useMemo } from 'react';
import { createInventoryOperationsController } from '../../application/inventoryOperationsController';
import { inventoryOperationsPortLive } from '../../application/inventoryOperationsPortLive';

export function useInventoryOperationsController() {
  return useMemo(() => createInventoryOperationsController(inventoryOperationsPortLive), []);
}
